<template>
  <div class="mania">
    <b-container>
      <div class="overlay-wrapper">
        <b-overlay :show="overlayShow" spinner-variant="warning" spinner-type="grow" rounded="lg">
          <div class="inner">
            <p class="smParagraph">06/04/20</p>
            <h2>Весенняя МАНИ-МАНИЯ</h2>
            <p class="smParagraph smParagraph_border">OZ MALL Краснодар</p>
            <div class="wrapper" @click.prevent="maniaPush">
              <div class="img-bg"></div>
              <div class="img-bg"></div>
              <div class="img-bg"></div>
            </div>
            <div class="link-container">
              <a @click.prevent="maniaPush" class="more xs-none">
                Подробнее
                <img src="@/assets/images/more-arrow.svg" alt />
              </a>
              <a @click.prevent="maniaPush" class="button xs-appear text-center">Подробнее</a>
            </div>
          </div>
        </b-overlay>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      overlayShow: false
    };
  },
  methods: {
    maniaPush() {
      this.overlayShow = !this.overlayShow;
      setTimeout(() => {
        this.overlayShow = !this.overlayShow;
        this.$router.push({ name: "blog", params: { isMania: true } });
      }, 500);
    }
  }
};
</script>
